<template>
    <div class="footer-wrapper">
       <div class="btm-logo-wrapper">
        <v-img
          alt="Maxicash Logo"
          class="shrink"
          contain
          src="../assets/common/maxicash-logo.png"
          transition="scale-transition"
          width="200px"
        />
        <label class="copyright-label">Copyright 2020, Maxi-Cash</label>
      </div>
      <div class="detail-groups-wrapper">
        <div class="detail-group">
          <label class="group-title">Services</label>
          <label class="group-item">E-Shop</label>
          <label class="group-item">Maxi-Cash App</label>
          <label class="group-item">Value Now</label>
        </div>
        <div class="detail-group">
          <label class="group-title">Support</label>
          <label class="group-item">Contact Us</label>
          <label class="group-item">FAQS</label>
          <label class="group-item">Shipping & Returns</label>
          <label class="group-item">Tax and Insurance</label>
        </div>
        <div class="detail-group">
          <label class="group-title">Info</label>
          <label class="group-item">Cookie Policy</label>
          <label class="group-item">Privacy Policy</label>
          <label class="group-item">Terms of Use</label>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.footer-wrapper {
  display: flex;
  background-color: #204281;
  height: fit-content;
  padding-top: 50px;
  padding-bottom: 50px;
}

.btm-logo-wrapper {
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.copyright-label {
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
  width: 200px;
}

.detail-groups-wrapper {
  display: flex;
  flex-grow: 1;
}

.detail-group {
  display: flex;
  color: white;
  height: 100%;
  flex-basis: 33%;
  align-items: flex-start;
  flex-direction: column;
}

.group-title, .group-item {
  padding-bottom: 5px;
}

.group-title {
  font-size: 12px;
}

.group-item {
  cursor: pointer;
}

.group-item, .copyright-label {
  font-size: 10px;
  font-weight: 100;
  color: rgb(233, 233, 233);
}

@media only screen and (max-width: 550px) {
  .footer-wrapper {
    flex-direction: column;
  }

  .btm-logo-wrapper {
    align-items: flex-start;
    width: 100%;
    padding-bottom: 25px;
  }

  .footer-wrapper {
    padding: 25px;
  }
}
</style>
